import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { CartTotalDisplayComponent } from "./components/cart-total-display/cart-total-display.component";
import { CartDisplayComponent } from "./components/cart-display/cart-display.component";
import { TenderCutsDatePipe } from "./pipes/tdate";
import { WeightPipe } from "./pipes/weight";
import { InvoicePage } from "./home/invoice/invoice.page";
import { NgxBarcodeModule } from "ngx-barcode";
import { CarryBagComponent } from "./components/carry-bag/carry-bag.component";
import { ComboListComponent } from "./components/combo-list/combo-list";
import { OrderDisplayComponent } from "./components/order-display/order-display.component";
@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, NgxBarcodeModule],
  declarations: [
    CartTotalDisplayComponent,
    CartDisplayComponent,
    TenderCutsDatePipe,
    WeightPipe,
    InvoicePage,
    CarryBagComponent,
    ComboListComponent,
    OrderDisplayComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CartTotalDisplayComponent,
    CartDisplayComponent,
    InvoicePage,
    CarryBagComponent,
    ComboListComponent,
    OrderDisplayComponent
  ],
})
export class SharedModule {}
